import RecoverStep from "../recover_step";
import axios from "../../../../axios-instance";
import {createFormData} from "../../../../modules/helpers/form-data-helper";

const TEMPLATE = 'export-complete';

export default class ExportComplete extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    axios.post(`/ftps_export/ftps_credentials`, createFormData({
      password: data.recovery.password,
      export_id: data.recovery.export_uuid
    })).then(response => {
      const responseData = response.data;
      data.render.ftpsExport = {
        host: responseData.host,
        login: responseData.login,
        password: responseData.password,
        expirationDays: responseData.expirationDays,
        ftpClientsLink: responseData.ftpClientsLink,
      }
      fr.render('exportComplete');

      const links = document.querySelectorAll('.input-link');
      links.forEach(link => {
        link.addEventListener('click', () => {
          const input = link.parentElement.querySelector('axs-input');
          const valueToCopy = input.value;
          navigator.clipboard.writeText(valueToCopy).then(() => {});
        });
      });
    });
  }

  transitionAnotherExport(data, el, fr) {
    fr.goTo('typeRB');
  }
}
